import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Button } from 'reakit/Button'
import { useCookie } from 'react-use'
import { debounced } from '../../imports/utils'
import Cookie from '../customIcons/Cookie'

import styles from './CookieBanner.module.scss'

const CookieBanner = props => {
    const { t } = useTranslation()
    const [cookieValue, setCookie] = useCookie('cookie_policy_agreement')

    useEffect(() => {
        window.addEventListener(
            'scroll',
            debounced(300, manageShowScrollTopBtn)
        )
    }, [])

    useEffect(() => {
        return () => {
            window.removeEventListener(
                'scroll',
                debounced(300, manageShowScrollTopBtn)
            )
        }
    }, [])

    const manageShowScrollTopBtn = () => {
        if (window.scrollY > 200) {
            setCookie(true)
        }
    }

    return !cookieValue ? (
        <div className={styles.cookieBanner}>
            <div className={styles.containerCookieBanner}>
                <span className={styles.wrapperCookieBanner}>
                    <header className={styles.header}>
                        <Cookie className={styles.icon} />
                        <h2 className={styles.title}>
                            {t('this_website_uses_cookies')}
                        </h2>
                    </header>
                    <p className={styles.text}>
                        {t('cookies_short_explanation')}
                    </p>
                    <Link to='/cookies-policy' className={styles.link}>
                        <p className={styles.text}>{t('learn_more')}</p>
                    </Link>
                    <Button
                        as='button'
                        className={styles.button}
                        onClick={() => setCookie(true)}
                    >
                        {t('accept')}
                    </Button>
                </span>
            </div>
        </div>
    ) : null
}

export default CookieBanner
